import React, { Component } from "react";

interface Props {
    branstyle?: string;
}

class Brand extends Component<Props>{
    render(): React.ReactNode{
        const {branstyle } = this.props;
        return(
            <React.Fragment>
                <ul className={`brand-list ${branstyle}`} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <style>{`
                        @media (max-width: 767px) {
                            .brand-list { flex-direction: column !important; align-items: center; }
                        }
                    `}</style>
                    <li>
                        <img src="/assets/images/logo/atourin_logo.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/logo/simedic_logo.png"  style={{ marginBottom: '12px'}}  alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/logo/ps_logo.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/logo/go4australia_logo.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/logo/outlier_logo.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/logo/alignerr_logo.png" alt="Logo Images"/>
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}
export default Brand;